import React from 'react';
import { GraphIcon, CloudIcon, GearIcon, BarChartIcon, RocketIcon } from '../components/Icons';

const INSIGHTS = [
  {
    icon: <GraphIcon />, tag: 'Architecture',
    title: 'Why API-First Avoids Point-to-Point Integration Hell',
    desc: 'APIs create a reusable access layer that prevents direct system coupling, reducing integration complexity and maintenance cost by up to 40%.',
    readTime: '5 min read',
  },
  {
    icon: <CloudIcon />, tag: 'SAP BTP',
    title: 'SAP BTP Integration Suite: Where to Start in 2024',
    desc: 'A practical roadmap for adopting SAP BTP — CPI, API Management, Event Mesh and Cloud Connector — sequenced for maximum value.',
    readTime: '7 min read',
  },
  {
    icon: <GearIcon />, tag: 'ERP / CRM',
    title: 'Modern Operations with Odoo ERP and CRM',
    desc: 'How Odoo supports customer operations, payment disputes, case management and knowledge-base workflows out of the box.',
    readTime: '4 min read',
  },
  {
    icon: <BarChartIcon />, tag: 'Analytics',
    title: 'Building Executive Power BI Dashboards That Get Used',
    desc: 'The 5 design principles that separate dashboards executives actually use from ones that collect dust after launch.',
    readTime: '6 min read',
  },
  {
    icon: <RocketIcon />, tag: 'AI / Cloud',
    title: 'AI-Assisted Integration Migration: What Actually Works',
    desc: 'Our experience using LLMs to analyze legacy SOAP interfaces and generate REST mappings — what worked, what failed, and lessons learned.',
    readTime: '8 min read',
  },
];

export default INSIGHTS;
